import { Outlet, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { Layout } from './components/Layout';
import { RequireAdmin } from './components/RequireAdmin';
import { RequireAuth } from './components/RequireAuth';
import { AcceptInvitePage } from './pages/AcceptInvitePage';
import { DashboardPage } from './pages/DashboardPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { LoginPage } from './pages/LoginPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { SessionPage } from './pages/SessionPage';
import { SettingsPage } from './pages/SettingsPage';
import { SupportNewPage } from './pages/SupportNewPage';
import { SupportPage } from './pages/SupportPage';
import { SupportTicketPage } from './pages/SupportTicketPage';
import { UpgradePage } from './pages/UpgradePage';
import { AdminLayout } from './pages/admin/AdminLayout';
import { CategoriesPage, CategoryEditPage } from './pages/admin/CategoriesPage';
import { EmailPage } from './pages/admin/EmailPage';
import { PaymentsPage } from './pages/admin/PaymentsPage';
import { PhrasesPage, PhraseEditPage } from './pages/admin/PhrasesPage';
import { PlanEditPage } from './pages/admin/PlanEditPage';
import { PlansPage } from './pages/admin/PlansPage';
import { SupportCategoriesPage } from './pages/admin/SupportCategoriesPage';
import { UserAddPage, UserEditPage, UsersPage } from './pages/admin/UsersPage';

function AuthenticatedShell() {
  return (
    <RequireAuth>
      <Layout>
        <Outlet />
      </Layout>
    </RequireAuth>
  );
}

function AdminShell() {
  return (
    <RequireAdmin>
      <Layout>
        <AdminLayout />
      </Layout>
    </RequireAdmin>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Bare routes (no header/footer) */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/accept-invite/:token" element={<AcceptInvitePage />} />

        {/* Authenticated app shell */}
        <Route element={<AuthenticatedShell />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/learn/:categorySlug" element={<SessionPage />} />
          <Route path="/upgrade" element={<UpgradePage />} />
          <Route path="/upgrade/success" element={<UpgradePage />} />
          <Route path="/upgrade/cancelled" element={<UpgradePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/support/new" element={<SupportNewPage />} />
          <Route path="/support/:ticketNumber" element={<SupportTicketPage />} />
        </Route>

        {/* Admin */}
        <Route path="/admin" element={<AdminShell />}>
          <Route index element={<PlansPage />} />
          <Route path="plans" element={<PlansPage />} />
          <Route path="plans/:id" element={<PlanEditPage />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="categories/:id" element={<CategoryEditPage />} />
          <Route path="phrases" element={<PhrasesPage />} />
          <Route path="phrases/:id" element={<PhraseEditPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/new" element={<UserAddPage />} />
          <Route path="users/:id" element={<UserEditPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="email" element={<EmailPage />} />
          <Route path="support-categories" element={<SupportCategoriesPage />} />
        </Route>

        <Route element={<AuthenticatedShell />}>
          <Route path="*" element={<DashboardPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
